import { ValidationRules } from "../../../../../types/entrypoint.js";
import { ParamState } from "../../../../../types/state.js";
import { Action } from "../actions";

function initialAppMode(): AppState["mode"] {
  const pathnames = location.pathname.split("/").filter((part) => part !== "");
  if (pathnames.length === 1) {
    return "privat";
  }
  // Må types for flow.
  switch (pathnames[1]) {
    case "bedrift":
      return "bedrift";
    case "person":
      return "person";
    case "underkonto":
      return "underkonto";
    default:
      return "privat";
  }
}

export type AppState = {
  csrfToken: string;
  validationRules: Partial<ValidationRules>;
  params: ParamState;
  mode: "bedrift" | "underkonto" | "privat" | "person";
};

const initialState: AppState = {
  csrfToken: "",
  validationRules: {},
  params: {
    mode: "bedrift",
  },
  mode: initialAppMode(),
};

export default function appReducer(
  state: AppState = initialState,
  action: Action,
): AppState {
  switch (action.type) {
    case "SET_CONTROL_FLOW":
      return {
        ...state,
        params: action.payload,
      };
    case "STORE_ENTRYPOINT":
      return {
        ...state,
        csrfToken: action.entrypoint.csrfToken,
        validationRules: action.entrypoint.validationRules,
      };
    case "ORGANISATIONS_FETCHED":
      return {
        ...state,
        csrfToken: action.org.csrfToken,
      };
    default:
      return state;
  }
}
